import axios from 'axios';

export default {
    recalculate(productId) {
        return axios.post('/partslist/recalculate/', { productId });
    },
    calculate() {
        return axios.post(' /partslist/calculate/');
    },
    calculateForProduct(productId) {
        return axios.post('/partslist/calculateForProduct/', { productId });
    },
    remove(partslistId) {
        return axios.post('/partslist/remove/', { partslistId });
    },
    fetch(partslistId, productId) {
        return axios.post('/partslist/fetch/', { partslistId, productId });
    },
    updateRecord(payload) {
        return axios.post('/partslist/updateRecord/', payload);
    },
    addRecord(payload) {
        return axios.post('/partslist/addRecord/', payload);
    },
    removeRecord(recordId) {
        return axios.post('/partslist/removeRecord/', { recordId });
    },
    countForProductionDate(maxProductionDate, types, paintshop = null) {
        return axios.post('/partslist/countForProductionDate/', {
            maxProductionDate,
            types,
            paintshop,
        });
    },
    processForProductionDate(
        maxColors,
        maxProductionDate,
        calculatePaintlist,
        types = [],
        paintshop = null
    ) {
        return axios.post('/partslist/processForProductionDate/', {
            maxColors,
            maxProductionDate,
            calculatePartslistsAndOptimizedpaintlistsFirst:
                calculatePaintlist || undefined,
            types,
            paintshop,
        });
    },
    calculateWithDeliveryDate(workDays) {
        return axios.post('/partslist/calculateWithDeliveryDate/', {
            workDays,
        });
    },
    calculateWithProductionDate(workDays, paintshop) {
        return axios.post('/partslist/calculateWithProductionDate/', {
            workDays,
            paintshop,
        });
    },
};
